import { render, staticRenderFns } from "./CrmUserCompanyClothe.vue?vue&type=template&id=1b3c9931&scoped=true&"
import script from "./CrmUserCompanyClothe.vue?vue&type=script&lang=js&"
export * from "./CrmUserCompanyClothe.vue?vue&type=script&lang=js&"
import style0 from "./CrmUserCompanyClothe.vue?vue&type=style&index=0&id=1b3c9931&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3c9931",
  null
  
)

export default component.exports